import React from "react";

import { endOfDay, startOfDay } from "date-fns";

import { useAuth, useTealium } from "@hubcapp/context";
import useQueryCalendarEvents from "@hubcapp/components/Calendar/hooks/useQueryCalendarEvents";

import { LessonSummary } from "./types";
import { mapEventsToLessonSummaries } from "./utils";
import CalendarSummary from "./CalendarSummary";

const CalendarSummaryStateProvider: React.FC = () => {
  const { trackEvent } = useTealium();
  const {
    instructor: { id },
  } = useAuth();

  const { data, loading } = useQueryCalendarEvents({
    startDate: startOfDay(new Date(Date.now())),
    endDate: endOfDay(new Date(Date.now())),
    instructorId: id,
  });

  const lessonSummaries: Array<LessonSummary> = mapEventsToLessonSummaries(
    data?.instructor?.calendarEvents || [],
  );

  const handleViewCalendar = () => {
    trackEvent({
      eventCategory: "Homepage",
      eventAction: "Interaction",
      eventLabel: "View Calendar",
    });
  };

  return (
    <CalendarSummary
      lessons={lessonSummaries}
      loading={loading}
      handleViewCalendar={handleViewCalendar}
    />
  );
};

export default CalendarSummaryStateProvider;
